import { useState, MouseEvent, useRef } from "react";
import { useNodeId } from "@xyflow/react";
import { Icon } from "@zapier/zinnia-icons";
import classNames from "classnames";

import styles from "./AddStepButton.module.css";
import { AddStepMenu } from "../AddStepMenu";
import useOutsideClick from "../../hooks/useOutsideClick";
import { HANDLE_DIST_FROM_TOP } from "@zapier/canvas-constants";

function AddStepButton({
  handleType = "source",
  distanceFromTop = HANDLE_DIST_FROM_TOP, // Must match handle CSS for default & zap nodes
}: {
  handleType?: "target" | "source";
  distanceFromTop?: number;
}) {
  const id = useNodeId();
  const ref = useRef<HTMLDivElement>(null);
  const [isHandleMenuVisible, setIsHandleMenuVisible] =
    useState<boolean>(false);

  const onHandleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // Prevent sidebar from opening
    setIsHandleMenuVisible((prevState) => !prevState);
  };

  const onContextMenuClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // Need this or else the current step will be selected. We want to select the newly added step(s).
    setIsHandleMenuVisible(false);
  };

  const onClickOutside = () => {
    setIsHandleMenuVisible(false);
  };

  useOutsideClick(ref, onClickOutside);

  return (
    <div
      ref={ref}
      className={classNames(styles.buttonWrapper, {
        [styles.buttonWrapperTarget]: handleType === "target",
        [styles.buttonWrapperSource]: handleType !== "target",
      })}
      style={{
        top: distanceFromTop,
      }}
    >
      <button
        className={styles.buttonNoStyle}
        onClick={onHandleClick}
        data-testid={`AddStepButton_${id}_${handleType}`}
      >
        {isHandleMenuVisible ? (
          <XIcon />
        ) : (
          <Icon name="formAdd" size={40} color="PrimeWhite" />
        )}
      </button>
      {isHandleMenuVisible && (
        <AddStepMenu
          id={id}
          onClick={onContextMenuClick}
          handleType={handleType}
        />
      )}
    </div>
  );
}

function XIcon() {
  return (
    <span className={styles.xIcon}>
      <Icon name="formAdd" size={40} color="PrimeWhite" />
    </span>
  );
}

export default AddStepButton;
